import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fm55nsdjga: FaireBrandEntity = {
  token: "b_fm55nsdjga",
  type: "brand",
  name: "ULTRAVIOLET BOOKS",
  avatarUrl: "https://cdn.faire.com/fastly/3739e8a90969352c2014fa7fcc7f471445bd038f97d3aae1daeff4d435d55bc9.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/94dea762dd9a7f16758bcd7ed30dea639052c798093b6facbee6107de6a81776.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/3739e8a90969352c2014fa7fcc7f471445bd038f97d3aae1daeff4d435d55bc9.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/94dea762dd9a7f16758bcd7ed30dea639052c798093b6facbee6107de6a81776.jpeg",
  location: "Santa Barbara, CA, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description: "Hi, Im Rachel. I started ULTRAVIOLET BOOKS in order to print small paperback poetry books like the old city lights pocket poetry series I love so much. Planning on some more beautiful books coming soon++\n\n",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:04.674Z",
    importedBy: "entity-db-cli"
  }
};
